import { useContext, useRef } from 'react';

// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';
import { SupporterPeriod } from '@/components/SupporterPeriod/SupporterPeriod';
import { SupporterTier } from '@/components/SupporterTier/SupporterTier';

const MAXIMUM_AMOUNT = '1000';

const SupporterTabs = () => {
	const [state, dispatch] = useContext(Context);
	const inputEl = useRef<React.ElementRef<'input'>>(null);

	return (
		<>
			<ul
				className="selectperiod"
				key="supporterTab"
			>
				<SupporterPeriod
					id="single"
					labelText="Einmalig"
				/>
				<SupporterPeriod
					id="monthly"
					labelText="Monatlich"
				/>
				<SupporterPeriod
					id="yearly"
					labelText="Jährlich"
				/>
			</ul>

			<ul className="selectoffer">
				<SupporterTier
					checked={state.supporter.tiers.low === state.supporter.selection.tier}
					id="low"
				/>
				<SupporterTier
					checked={state.supporter.tiers.mid === state.supporter.selection.tier}
					id="mid"
				/>
				<SupporterTier
					checked={state.supporter.tiers.high === state.supporter.selection.tier}
					id="high"
				/>
				<SupporterTier
					checked={inputEl?.current === document.activeElement}
					id="custom"
					onClick={() => inputEl.current?.focus()}
				>
					<span>
						<input
							data-validation-error={`Der Betrag darf nur zwischen ${state.supporter.minimumAmount} und €1000 liegen`}
							id="customValue"
							inputMode="decimal"
							max={MAXIMUM_AMOUNT}
							min={state.supporter.minimumAmount}
							name="customValue"
							onChange={(event) => {
								dispatch({
									type: ActionTypes.supporterChangeTier,
									payload: {
										key: 'supporter.selection.tier',
										value: event.target.value.substring(0, MAXIMUM_AMOUNT.length)
									}
								});
							}}
							ref={inputEl}
							required={Object.values(state.supporter.tiers).includes(state.supporter.selection.tier) ? false : true}
							type="number"
							value={state.supporter.selection.tier ? state.supporter.selection.tier : ''}
						/>
					</span>
				</SupporterTier>
			</ul>
		</>
	);
};

export { SupporterTabs };
